var ServicesModule = /** @class */ (function () {
    function ServicesModule() {
    }
    return ServicesModule;
}());
export { ServicesModule };
